<template>
    <div class="x_box A4">
        <div class="x_body">
            <div class="print-header font-m" style="display: flex; justify-content: space-between">
                <div>
                    <img :src="img" alt="" class="img-thumbnail" style="width: 135px; height: 125px;">
                </div>
                <div>
                    <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
                    <h2 class="text-center" style="font-weight: bold;">{{company.LatinName}}</h2>
                    <div style="font-size: 13px;">
                        <b>{{$t('address')}}៖ </b>
                        {{$t('home_no')}} {{company.Home}} {{$t('village')}} {{company.Village}} {{$t('commune')}} {{company.Commune}} {{$t('district')}} {{company.District}} {{$t('capital')}} {{company.Capital}}
                    </div>
                    <div style="font-size: 13px;">
                        <b>{{$t('phone_contact')}}</b>
                        {{company.Phone}} <span>{{$t('email')}}</span>: {{company.Email}}
                        <br>
                        លេខអត្តសញ្ញាណកម្មសារពើពន្ធ​អតប (VAT): {{company.TinHead}}-{{company.VatTin}}
                    </div>
                </div>
            </div>
            <div style="height: 2px; border: 1px solid black; width: 100%; background: black; margin-bottom: 20px"></div>
            <h4 class="text-center font-m">{{$t('report_customer_loan')}}</h4><br>
            <table class="table table-bordered table-sm table-striped no-bor">
                <thead>
                <tr>
                    <th style="width: 50px;">#</th>
                    <th>{{$t('customer')}}</th>
                    <th class="text-right">{{$t('balance')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(ret, index) in list" :key="index">
                    <td>{{index+1}}</td>
                    <td>{{ret.CustomerName}}</td>
                    <td class="text-right">{{$money(ret.Balance + ret.Balance)}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                company: {},
                query:{
                    FromDate: '',
                    ToDate: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25
                },
                list: [],
                summary: {
                    balance: 0
                },
                img: '/img/company-logo.png',
            }
        },
        created: function(){
            this.toList();
            this.getCompany();
        },
        methods: {
            getCompany: function() {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                    if(this.company.Logo != null){
                        this.img = this.$base() + 'image/logo/' + this.company.Logo;
                    }
                });
            },

            toList(){
                var loading = this.$loading.show();
                this.$api().post('sale/invoices', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.list = res.data.Data;
                    }
                }).finally(function() { loading.hide(); });
            },
            print() {
                window.open(
                    "/print/ARPreview",
                    "_blank"
                );
            }
        }
    }
</script>
